import { render } from "./EmptyPage.vue?vue&type=template&id=54b751b4&scoped=true"
import script from "./EmptyPage.vue?vue&type=script&lang=js"
export * from "./EmptyPage.vue?vue&type=script&lang=js"

import "./EmptyPage.vue?vue&type=style&index=0&id=54b751b4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b751b4"]])

export default __exports__